<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <v-dialog v-model="dialog" width="1000" hegiht="auto" persistent>
          <template v-slot:activator="{ on }">
            <v-flex xs12 md4>
              <v-btn color="success" dark v-on="on">
                Create new crash course
              </v-btn>
            </v-flex>
          </template>

          <v-card>
            <v-container>
              <material-card title="Create New Crash Course" color="green">
                <v-form ref="formCrashCourse" v-model="valid" lazy-validation>
                  <v-container py-0>
                    <v-layout wrap>
                      <v-flex md6>
                        <v-text-field
                          type="text"
                          label="Course Name"
                          class="green-input"
                          v-model="courseObj.name"
                          prepend-icon="text_fields"
                          :rules="nameRules"
                        />
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          type="text"
                          label="Course Name (বাংলা)"
                          class="green-input"
                          v-model="courseObj.name_bn"
                          prepend-icon="text_fields"
                        />
                      </v-flex>
                      <v-flex md12>
                        <v-textarea
                          label="Description"
                          class="green-input"
                          v-model="courseObj.description"
                          :rules="decriptionRules"
                        ></v-textarea>
                      </v-flex>


                      <v-flex md12>  
                       <material-card >
                       <v-layout wrap >
                        <v-flex md12>
                        <h4 style="float:left">Description Title & Details</h4>
                       <v-btn class="mx-2 font-weight-light" style="float:right" color="danger" small @click="decreaseDescriptionTitles">Remove des. title</v-btn>
                       <v-btn class="mx-2 font-weight-light" style="float:right" color="success" small @click="increaseDescriptionTitles">Add more des. title</v-btn>
                            </v-flex>
                         </v-layout>

                        <v-layout wrap v-for="(titles, index) in description_titles" :key="index">
                        <v-flex md12>

                        <v-text-field
                          type="text"
                          label="Title "
                          class="green-input"
                          v-model="description_titles[index].title"  
                          :rules="desTitleRules"                       
                        /></v-flex>
                       
                          <v-flex md12>

                      <v-textarea
                          label="Details (Use || for multiple)"
                          class="green-input"
                           v-model="description_titles[index].details"
                           :rules="desTitleDetailsRules"
                        ></v-textarea>
                      </v-flex>
                       
                        <hr>
                        </v-layout>
                         </material-card>
                      </v-flex>

                     

                      <v-flex md12>  
                        <material-card >
                      <v-layout wrap >
                        <v-flex md12>
                        <h4 style="float:left">Features</h4>
                       <v-btn class="mx-2 font-weight-light" style="float:right" color="danger" small @click="decreaseFeature">Remove Feature</v-btn>
                       <v-btn class="mx-2 font-weight-light" style="float:right" color="success" small @click="increaseFeature">Add Feature</v-btn>
                            </v-flex>
                         </v-layout>
                   

                        <v-layout wrap v-for="(feature, index) in features" :key="index">
                        <v-flex md8>
                        <v-text-field
                          type="text"
                          label="Feature"
                          class="green-input"
                          v-model="features[index].name"
                           :rules="packageDetailsRules"
                        /></v-flex>
                       
                        </v-layout>
                         </material-card>
                      </v-flex>

                      <v-flex md6>
                        <v-text-field
                          type="text"
                          label="Youtube Url"
                          class="green-input"
                          v-model="courseObj.youtube_url"
                        />
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          v-model="thumbnailName"
                          label="Thumbnail"
                          @click="pickThumbnail"
                          prepend-icon="attach_file"
                          class="green-input"
                        ></v-text-field>
                        <input
                          type="file"
                          style="display: none"
                          ref="thumbnail"
                          accept="image/*"
                          @change="onThumbnailPicked"
                          :rules="thumbnailRule"
                        />
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          v-model="iconThumbnailName"
                          label="Icon"
                          @click="pickIconThumbnail"
                          prepend-icon="attach_file"
                          class="green-input"
                        ></v-text-field>
                        <input
                          type="file"
                          style="display: none"
                          ref="iconThumbnail"
                          accept="image/*"
                          @change="onIconThumbnailPicked"
                        />
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          type="text"
                          label="Coupon Code"
                          class="green-input"
                          v-model="courseObj.coupon_code"
                        />
                      </v-flex>

                    <!--  <v-flex md4>
                        <v-textarea
                          label="Package Contact"
                          class="green-input"
                          v-model="courseObj.package_contact"
                          :rules="packageContactRules"
                        ></v-textarea>
                      </v-flex>-->
                      <v-flex md6>
                        <v-text-field
                          type="number"
                          label="Regular Price"
                          class="green-input"
                          v-model="courseObj.regular_amount"
                          :rules="regPriceRules"
                        />
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          type="number"
                          label="Sales Price"
                          class="green-input"
                          v-model="courseObj.sales_amount"
                          :rules="salesPriceRules"
                        />
                      </v-flex>
                      <v-flex md6>
                        <v-select
                          :items="promoStatusList"
                          label="Select promo status"
                          item-text="name"
                          item-value="id"
                          class="pt-1"
                          v-model="courseObj.promo_status"                          
                        ></v-select>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          type="number"
                          label="Sort"
                          class="green-input"
                          v-model="courseObj.sort"
                          :rules="sortRules"
                        />
                      </v-flex>
                         <v-flex md3>
                        <v-text-field
                          type="text"
                          label="Folder Name (Must be in english)"
                          class="green-input"
                          v-model="courseObj.folder_name"
                          :rules="folderRules" 
                        />
                      </v-flex>
                   

                      <v-flex md3>
                        <b>Is Only Exam ?</b>
                        <v-radio-group
                          v-model="courseObj.is_only_test"
                          row
                          :rules="onlyTestRule"
                        >
                          <v-radio label="Yes" value="1"></v-radio>
                          <v-radio label="No" value="0"></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex md3>
                        <b>Has Trail ?</b>
                        <v-radio-group
                          v-model="courseObj.has_trail"
                          row
                          :rules="hasTrailRule"
                        >
                          <v-radio label="Yes" value="1"></v-radio>
                          <v-radio label="No" value="0"></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex md3>
                        <b>Is Active ?</b>
                        <v-radio-group
                          v-model="courseObj.is_active"
                          row
                          :rules="isActiveRule"
                        >
                          <v-radio label="Yes" value="1"></v-radio>
                          <v-radio label="No" value="0"></v-radio>
                        </v-radio-group>
                      </v-flex>

                      <v-flex xs12 text-xs-right>
                        <v-btn
                          class="mx-0 font-weight-light"
                          color="success"
                          :disabled="disableButton"
                          @click="onCrashCourseSubmit"
                          >Submit</v-btn
                        >
                        <v-btn
                          class="mx-2 font-weight-light"
                          color="info"
                          :disabled="disableButton"
                          @click="closeModal"
                          >Close</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </material-card>
            </v-container>
          </v-card>
        </v-dialog>
        <material-card
          color="green"
          title="Crash Course List"
          text="The crash courses those are being provided by BacBon"
        >
          <v-data-table :headers="headers" :items="crashCourseList">
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td> <vue-mathjax :formula="item.name"></vue-mathjax> </td>
              <td>{{ item.is_active }}</td>
              <td>{{ item.sort }}</td>
              <td>
               <!-- <v-btn
                  color="success"
                  fab
                  small
                  dark
                  round
                  @click="enableEdit(item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn> -->
              </td>
            </template>
          </v-data-table>

          <v-dialog v-model="dialogEdit" width="1000" hegiht="auto" persistent>
            <!--       <template v-slot:activator="{ on }">
            
          </template> -->

            <v-card>
              <!--  <FormCourseEdit
              :CourseTypeList="courseTypeList"
              :Item="item"
              :Field="inputFields"
              :Value="course"
              @emitted="EditCourse"
              @closed="closeModal"
              /> -->
            </v-card>
          </v-dialog>
        </material-card>

        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
          <div>{{ errorMessage }}</div>
          <v-icon size="16" @click="snackbar = false">
            mdi-close-circle
          </v-icon>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import FormCourseEdit from "@/views/FormCourseEdit";
import { VueMathjax } from 'vue-mathjax'
export default {
  components: {
    FormCourseEdit,
     'vue-mathjax': VueMathjax
  },
  computed: {
    ...mapState("crashCourses", ["crashCourseList"]),
  },
  mounted() {
    this.getCrashCourselist();
    this.reRender();
  },
  data() {
    return {
      latex:
        "When \(x = {-b \\pm \\sqrt{b^2-4ac} \\over 2a}\), there are two solutions to \(ax^2 + bx + c = 0\) and they are",
      promoStatusList: [
        { id: "Free", name: "Free" },
        { id: "Hot", name: "Hot" },
        { id: "New", name: "New" },
      ],
      valid: true,
      color: null,
      colors: ["warning"],
      features:[{name:''}],
      description_titles:[{title:'',details:''}],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      list : [],
      course: {},
      headers: [
        {
          sortable: true,
          text: "Crash Course",
          value: "name",
        },
        {
          sortable: true,
          text: "Status",
          value: "status",
        },
        {
          sortable: true,
          text: "Sort",
          value: "sort",
        },
        {
          sortable: false,
          text: "Action",
          value: "action",
        },
      ],
      dialog: false,
      dialogEdit: false,
      errorMessage: "",
      item: {
        title: "Create New Crash Course",
        subTitle: "This is the subtitle",
        width: "md6",
        submitText: "Submit",
      },
      courseObj: {},
      thumbnailName: "",
      iconThumbnailName: "",
      thumbnailRule: [(v) => !!v || "Thumbnail is required."],
      nameRules: [
        (v) => !!v || "Course name is required",
        (v) =>
          (v && v.length <= 190) ||
          "Course name must be less than 190 characters",
      ],
      decriptionRules: [
        (v) => !!v || "Description is required",
        (v) =>
          (v && v.length <= 500) ||
          "Description must be less than 500 characters",
      ],
      packageDetailsRules: [
        (v) => !!v || "features is required",
        (v) =>
          (v && v.length <= 500) || "Details must be less than 500 characters",
      ],
      desTitleRules: [
        (v) => !!v || "title is required",
        (v) =>
          (v && v.length <= 500) || "title must be less than 500 characters",
      ],
      desTitleDetailsRules: [
        (v) => !!v || "details is required",
        (v) =>
          (v && v.length <= 500) || "Details must be less than 500 characters",
      ],
      regPriceRules: [(v) => !!v || "Price is required"],
      salesPriceRules: [(v) => !!v || "Price is required"],
      onlyTestRule: [(v) => !!v || "Only Test is required."],
      hasTrailRule: [(v) => !!v || "Has Trail is required."],
      isActiveRule: [(v) => !!v || "Has Trail is required."],
      sortRules: [(v) => !!v || "Sort is required"],
      promoRules: [(v) => !!v || "Promo Status is required"],
      packageContactRules: [(v) => !!v || "Package contact is required"],
      folderRules: [(v) => !!v || "Folder name is required"],
      disableButton: false,

    };
  },
  created() {
    // this.getCourseTypeList()
  },
  methods: {
    ...mapActions("crashCourses", [
      "createCrashCourse",
      "getCrashCourselist",
      "updateCourse",
    ]),
   reRender() {
     this.$nextTick(function() {
						 MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
			});
      // if (window.MathJax) {
      //   window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
      //     console.log("done")
      //   );
      // }
    }, 
    enableEdit(item) {
      this.course = item;
      this.dialogEdit = true;
    },
  increaseFeature () {
      this.features.push({
          name: null         
        });
    },
    decreaseFeature () {
    
      if(this.features.length > 1){
        this.features.pop();   
      }         
    },
    
  increaseDescriptionTitles () {
      this.description_titles.push({
          title: null,        
          details: null         
        });
    },
    decreaseDescriptionTitles () {
     
      if(this.description_titles.length > 1){
        this.description_titles.pop();   
      }
         
    },
    closeModal() {
      this.dialog = false;
      this.$refs.formCrashCourse.reset();
      this.$refs.thumbnail.value = null;
      this.$refs.iconThumbnail.value = null;
      this.thumbnailName = '';
      this.iconThumbnailName = '';
      this.courseObj = {}
      this.features = [];
      this.description_titles = [];
      this.increaseFeature();
      this.increaseDescriptionTitles();

    },
    pickThumbnail() {
      this.$refs.thumbnail.click();
    },
    onThumbnailPicked(e) {
      this.thumbnailName = e.target.files[0].name;
    },
    pickIconThumbnail() {
      this.$refs.iconThumbnail.click();
    },
    onIconThumbnailPicked(e) {
      this.iconThumbnailName = e.target.files[0].name;
    },
    onCrashCourseSubmit() {
      let iconThumbnail = this.$refs.iconThumbnail.files[0];
      let thumbnail = this.$refs.thumbnail.files[0];
      if (this.$refs.formCrashCourse.validate()) {
        // let packageDetails = {
        //   price: Number(this.courseObj.sales_amount),
        //   old_price: Number(this.courseObj.regular_amount),
        //   referral_discount: "",
        //   package_name: this.courseObj.name,
        //   contact_number: this.courseObj.package_contact,
        //   features: this.courseObj.package_details.split(","),
        // };
        // this.courseObj.packageInfo = JSON.stringify(packageDetails);

       
        let desTitles = [];
        this.description_titles.forEach(element => {
            desTitles.push(
              {
                "title":element.title,
                "details":element.details.split("||")
              }
            )
        });

        this.courseObj.features = this.features;
        this.courseObj.desTitles = desTitles;
        console.log(this.courseObj)

        var formData = new FormData();
        formData.append("data", JSON.stringify(this.courseObj));
        formData.append("iconThumbnail", iconThumbnail);
        formData.append("thumbnail", thumbnail);

        this.disableButton = true;

        this.createCrashCourse(formData)
          .then((response) => {
            
            if (response.status == "OK") {
              this.closeModal();
               this.$refs.formCrashCourse.resetValidation();
              this.disableButton = false;
              this.getCrashCourselist();
              this.color = "success";
              this.errorMessage = response.messages;
              this.snack("top");
            } else {
              this.errorMessage = response.messages;
              this.snack("top");
              this.disableButton = false;
            }
          })
          .catch((err) => {
            this.disableButton = false;
            console.log(err);
          });
      } else {
      }
    },

    // EditCourse(data) {
    //   this.updateCourse(data)
    //     .then((response) => {
    //       if (response.status == "OK") {
    //         this.getCrashCourselist();
    //         this.dialogEdit = false;
    //         this.color = "success";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       } else {
    //         this.dialogEdit = false;
    //         this.color = "warning";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    // getBackData(data) {
    //   this.CreateCourse(data)
    //     .then((response) => {
    //       console.log(response);
    //       if (response.status == "OK") {
    //         this.getCrashCourselist();
    //         this.dialog = false;
    //         this.color = "success";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       } else {
    //         this.dialog = false;
    //         this.color = "warning";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
  // watch: {
  //   crashCourseList: function() {
  //     console.log('data changed')
  //     this.reRender();
  //   }
  // },
    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = this.colors[Math.floor(Math.random() * this.colors.length)];

      this.snackbar = true;
    },
  },
};

</script>
    <!-- <script type="text/x-mathjax-config">
      MathJax.Hub.Config({
        tex2jax: { inlineMath: [["$$", "$$"]],displayMath:[["$$$", "$$$"]] }
      });
    </script> -->
